import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { CloseIcon, PLusIcon } from "../../assets/Icons";
import axios from "axios";
import Select, { components } from "react-select";
import { UNO_URL } from "../../Server";

const RenameFileModal = ({ show, onClose, file, handleFileRenameSubmit, userDetails, tagsList, getStorageCategoryTags }) => {

  const [newName, setNewName] = useState("");
  const [storageCategoryId, setStorageCategoryId] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagsOptions, setTagsOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  const getFileDetails = async (uuid) => {
    try {
      let { data } = await axios.get(`${UNO_URL}/api/drive/file/details/${uuid}`, {
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
        }
      });

      let tagsList = (data?.data?.tags || []).map(e => ({ id: e.id, value: e.name, label: e.name }));
      setNewName(data.data.name);
      setSelectedTags(tagsList);

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    setNewName(file?.name || null);
  }, [file]);

  useEffect(() => {
    if (show) {
      const storageConfig = localStorage.getItem("configuration");
      const configData = JSON.parse(storageConfig);
      const _storageCategoryId = configData?.storageCategoryId || null;
      setStorageCategoryId(_storageCategoryId);
      let _tagsList = (tagsList || []).map(e => ({ id: e.id, value: e.name, label: e.name }));
      setTagsOptions(_tagsList);
    }
  }, [show, tagsList]);

  useEffect(() => {
    setSelectedTags([]);
    if (file) {
      getFileDetails(file.uuid)
    }
  }, [file, userDetails])

  const handleCloseRenameModal = async () => {
    setStorageCategoryId(null);
    setSelectedTags([]);
    setTagsOptions([]);
    setInputValue("");
    setLoading(false);
    onClose();
  }

  const handleSave = () => {
    if (newName.trim().length) {
      let bodyData = {
        name: newName.trim(),
        tags: (selectedTags || []).map(e => e.id)
      }
      handleFileRenameSubmit(bodyData, file.uuid);
      handleCloseRenameModal();
    }
  };

  const handleCreateNewTag = async () => {
    if (!inputValue.trim()) return;
    setLoading(true);
    try {
      let bodyData = {
        name: inputValue.trim(),
        categoryId: Number(storageCategoryId)
      }

      await axios.post(`${UNO_URL}/api/tag/create`, bodyData, {
        headers: {
          "Authorization": `Bearer ${userDetails?.token}`,
          "Content-Type": "application/json"
        }
      });

      getStorageCategoryTags();

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const NoOptionsMessage = (props) => (
    <components.NoOptionsMessage {...props}>
      {loading ? 
      <>
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p>Creating tag</p>
      </>
:
      <div
        style={{
          padding: "8px",
          cursor: "pointer",
          color: "#2f3a79",
          textDecoration: "underline",
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          handleCreateNewTag();
        }}
      >
        <PLusIcon /> Add Tag
      </div>
      }
   
    </components.NoOptionsMessage>
  );

  return (
    <>
      <Modal size="lg" show={show} onHide={handleCloseRenameModal} centered backdrop={true} keyboard={true}>
        <Modal.Header>
          <Modal.Title>Rename File</Modal.Title>
          <button onClick={handleCloseRenameModal} className="close-s schedule-modal-button" type="button" title="Close">
            <CloseIcon />
          </button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form className="renamefileform">
            <Form.Group controlId="fileName">
              <Form.Label> File Name</Form.Label>
              <Form.Control
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                autoFocus
                placeholder="Edit file"
              />
            </Form.Group>
            <Form.Group controlId="fileName">
              <div className="addtags">
                <Select
                  isMulti
                  name="Tags"
                  className="basic-multi-select mt-2"
                  classNamePrefix="select"
                  placeholder="Select Tags"
                  options={tagsOptions}
                  value={selectedTags}
                  onChange={(selected) => setSelectedTags(selected || [])}
                  components={{ NoOptionsMessage }}
                  inputValue={inputValue} // controlled input
                  onInputChange={(value) => setInputValue(value)}
                  filterOption={(option, search) => {
                    if (!option || !option.label) return false; // avoid crash
                    return option.label.toLowerCase().includes(search.toLowerCase());
                  }}
                />
                {/* <input type="text" className="form-control" placeholder="Add Tag"/> */}
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="py-2 justify-content-end">
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RenameFileModal;
